export default __webpack_public_path__ + "static/media/12.95c9567e.png";